import { Loader } from "../net/Loader";
import { PAL } from "../platform/PlatformAdapters";
class TTFFontLoader {
    load(task) {
        return PAL.font.loadFont(task);
    }
}
Loader.registerLoader(["ttf", "woff", "woff2", "otf"], TTFFontLoader, Loader.TTF);
